<template>
  <div id="homePage">
    <div class="content" style="margin-top:-80px">
      <!-- home-section01 start -->
      <div class="home-section01 screen-first">
        <div class="blockW home-section01-con screen-first-con">
          <h1 class="slogan">云游无界一触即发</h1>
          <div class="video-box">
            <div class="btn-play">
              <a class="ico-play" href="javascript:;">
                <img src="~assets/img/img_video.jpg" alt class="imgsize" />
              </a>
            </div>
            <div id="showPlay">
              <video
                id="videoPlay"
                poster="~assets/img/img_video.jpg"
                src="https://www.zqcloudgame.com/video/cloudgame.mp4"
                controls
                x-webkit-airplay="allow"
              >
                <source src="https://www.zqcloudgame.com/video/cloudgame.mp4" type="v4/video/mp4" />
              </video>
            </div>
          </div>
        </div>
        <div class="scroll-more"></div>
      </div>
      <!-- home-section01 end -->

      <!-- home-section02 start -->
      <div class="home-section02">
        <div class="blockW">
          <div class="data-describle">
            <h3 class="sub-title sub-title01">无需下载，普通设备即可体验</h3>
            <p>
              游戏画面从服务器实时传输至玩家客户端，
              <br />玩家无需下载、安装和更新游戏，只需普通设备，即可立即体验
            </p>
          </div>
        </div>
      </div>
      <!-- home-section02 end -->

      <!-- home-section03 start -->
      <div class="home-section03">
        <div class="blockW">
          <div class="main-title main-title13">
            <h2>客户端</h2>
            <small>手边设备通过客户端轻松畅玩云游戏</small>
          </div>
          <div class="client-box">
            <ul class="client-tab clearfix">
              <li class="on">
                <i class="icon-client icon-android"></i>Android
              </li>
              <li>
                <i class="icon-client icon-androidTv"></i>Android TV
              </li>
              <li>
                <i class="icon-client icon-Windows"></i>Windows
              </li>
              <li>
                <i class="icon-client icon-Mac"></i>Mac
              </li>
              <li>
                <i class="icon-client icon-iOS"></i>iOS
              </li>
              <li>
                <i class="icon-client icon-UOS"></i>UOS
              </li>
            </ul>
            <div class="client-con">
              <dl class="client-info">
                <dt>
                  <img src="~assets/img/home/img_client_android.jpg" alt />
                </dt>
                <dd>
                  <h3 class="sub-title sub-title02" id="sub-title02">普通手机也能体验端游</h3>
                  <div id="sub-title02div"
                    style="background-color: #ffffff;width: 121px;height: 121px;overflow:hidden;position: relative;top: -80px;left: 180px;margin-bottom: -55px; border-radius: 5px;"
                    hidden>
                    <img
                      src="https://www.zqcloudgame.com/images/clientDownload/app.png"
                      style="margin:auto;margin-top: 3px;"
                    />
                  </div>
                  <a :href="downUrlApp" id="btn-type03_1" class="btn-type03_1">Download</a>
                </dd>
              </dl>

              <dl class="client-info">
                <dt>
                  <img src="~assets/img/home/img_client_androidTv.jpg" alt />
                </dt>
                <dd>
                  <h3 class="sub-title sub-title03" id="sub-title02_2">大屏沙发和手柄，怎么舒畅怎么玩</h3>
                  <div id="sub-title02div_2"
                       style="background-color: #ffffff;width: 121px;height: 121px;overflow:hidden;position: relative;top: -80px;left: 180px;margin-bottom: -55px; border-radius: 5px;"
                       hidden>
                    <img
                        src="https://www.zqcloudgame.com/images/clientDownload/app.png"
                        style="margin:auto;margin-top: 3px;"
                    />
                  </div>
                  <a :href="downUrlApp" id="btn-type03_2" class="btn-type03_1">Download</a>
                </dd>
              </dl>

              <dl class="client-info">
                <dt>
                  <img src="~assets/img/home/img_client_Windows.jpg" alt />
                </dt>
                <dd>
                  <h3 class="sub-title sub-title04">旧机焕新颜,畅玩3A大作</h3>
                  <a :href="downUrlPC" class="btn-type03_1">Download</a>
                </dd>
              </dl>

              <dl class="client-info">
                <dt>
                  <img src="~assets/img/home/img_client_macOS.jpg" alt />
                </dt>
                <dd>
                  <h3 class="sub-title sub-title05">无需双系统,突破系统限制,想玩就玩</h3>
                  <a href="javascript:;" class="btn-type03">敬请期待</a>
                </dd>
              </dl>

              <dl class="client-info">
                <dt>
                  <img src="~assets/img/home/img_client_iOS.jpg" alt />
                </dt>
                <dd>
                  <h3 class="sub-title sub-title06">不受空间限制，随时随地体验端游</h3>
                  <a href="javascript:;" class="btn-type03">敬请期待</a>
                </dd>
              </dl>
              <dl class="client-info uos-dl">
                <dt>
                  <img src="~assets/img/home/macOS.png" alt />
                </dt>
                <dd>
                  <h3 class="sub-title sub-title_UOS">国产操作系统，我们鼎力支持</h3>
                  <el-dropdown class="uos_drop">
                    <div class="width_main" style="width:150px">
                      <a href="javascript:;" class="btn-type03">Download</a>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item,index) in uosList"
                        :class="{'not_allowed': !item.url}"
                        @click="chooiseUos(item)"
                        :key="index"
                      >
                        <a :href="item.url">{{item.name}}</a>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- <div class="uos_main">
                    <a href="javascript:;" class="btn-type03">Download</a>
                    <ol class="uos_list">
                      <li v-for="(item,index) in uosList" :class="{'not_allowed': !item.url}"
                      @click="chooiseUos(item)" :key="index">
                      <a :href="item.url">{{item.name}}</a>
                      </li>
                    </ol>
                  </div>-->
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <!-- home-section03 end -->

      <!-- home-section04 start -->
      <div class="home-section04">
        <div class="blockW">
          <div class="main-title main-title14">
            <h2>丰富的操控方式</h2>
            <small>从硬件外设到虚拟按键的多种操控方式适配,游戏中更能得心应手</small>
          </div>
        </div>
      </div>
      <!-- home-section04 end -->

      <!-- home-section05 start -->
      <div class="home-section05">
        <div class="blockW">
          <div class="main-title main-title15">
            <h2>多种FPS选择</h2>
            <small>多种FPS选择：30FPS、60FPS、90FPS、120FPS，满足玩家不同游戏体验要求</small>
          </div>
          <div class="multiple-fps">
            <ul class="multiple-con">
              <li>
                <video
                  poster="~assets/img/home/img_fps01.jpg"
                  src="https://www.zqcloudgame.com/video/fps30.mp4"
                  autoplay
                  muted
                  loop
                  x-webkit-airplay="allow"
                ></video>
              </li>
              <li>
                <video
                  poster="~assets/img/home/img_fps02.jpg"
                  src="https://www.zqcloudgame.com/video/fps60.mp4"
                  loop
                  x-webkit-airplay="allow"
                ></video>
              </li>
              <li>
                <video
                  poster="~assets/img/home/img_fps03.jpg"
                  src="https://www.zqcloudgame.com/video/fps90.mp4"
                  loop
                  x-webkit-airplay="allow"
                ></video>
              </li>
              <li>
                <video
                  poster="~assets/img/home/img_fps04.jpg"
                  src="https://www.zqcloudgame.com/video/fps120.mp4"
                  loop
                  x-webkit-airplay="allow"
                ></video>
              </li>
            </ul>
            <div class="multiple-tab">
              <a href="javascript:;">30fps</a>
              <a href="javascript:;">60fps</a>
              <a href="javascript:;">90fps</a>
              <a href="javascript:;">120fps</a>
            </div>
          </div>
        </div>
      </div>
      <!-- home-section05 end -->

      <!-- home-section06 start -->
      <div class="home-section06">
        <div class="blockW">
          <div class="main-title main-title16">
            <h2>丰富内容 触手可及</h2>
          </div>
          <div class="pic-wall">
            <div class="pic-scroll">
              <img src="~assets/img/home/img_game.jpg" alt />
            </div>
          </div>
          <div class="logo-platform">
            <img src="~assets/img/home/img_platform_logo.png" width="1200" height="72" alt />
          </div>
        </div>
      </div>
      <!-- home-section06 end -->

      <!-- home-section07 start -->
      <div class="home-section07">
        <div class="blockW">
          <div class="main-title main-title17">
            <h2>
              丰富的游戏种类
              <br />最新热门的游戏，统统触手可及
            </h2>
          </div>
          <ul class="advantage-list">
            <li>
              <h4>无门槛</h4>
              <p>手边设备即连即玩</p>
            </li>
            <li>
              <h4>无等待</h4>
              <p>无需下载安装更新</p>
            </li>
            <li>
              <h4>无差别</h4>
              <p>发烧主机游戏体验</p>
            </li>
            <li>
              <h4>内容丰富</h4>
              <p>发烧主机游戏体验</p>
            </li>
            <li>
              <h4>全覆盖</h4>
              <p>数据中心遍布全国</p>
            </li>
            <li>
              <h4>全天候</h4>
              <p>24x365全天在线</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- home-section07 end -->

      <!-- home-section08 start -->
      <div class="home-section08">
        <div class="blockW hs08-con">
          <span class="txt-type01">准备好了吗？Ready go!</span>
          <a @click="$router.push('/login')" class="btn-blue hs08-spaec">立即注册</a>
          <a @click="$router.push('/client')" class="btn-green">立即下载</a>
        </div>
      </div>
      <!-- home-section08 end -->
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    },
    hasGuide() {
      return this.$store.state.hasGuide;
    },
    activityData() {
      return this.$store.state.activityData;
    },
    user() {
      return this.$store.state.user;
    }
  },
  data() {
    return {
      downUrlPC: "",
      downUrlApp: "",
      uosList: []
    };
  },
  methods: {
    async getUlr() {
      this.uosList = [];
      const res = await this.$http.downLoad();
      res.data.forEach(item => {
        if (item.clientType === "app") {
          this.downUrlApp = item.downloadUrl;
        }
        if (item.clientType === "pc") {
          this.downUrlPC = item.downloadUrl;
        }
        if (item.description === "uos") {
          this.uosList.push({
            name: item.clientType,
            url: item.downloadUrl
          });
        }
      });
      $(".uos_main").mouseenter(function() {
        $(".uos_list").show();
      });
      $(".uos_list,uos-dl dd").mouseleave(function() {
        console.log(554);
        $(".uos_list").hide();
      });
    },

    // 关闭新手引导
    closeGuide() {
      // this.hasGuide = false;
      this.$store.commit("setHasGuide", "no");
      // this.$refs.serverRoom.startSpeedTest()
    }
  },
  mounted() {
    this.getUlr();
    $(".btn-play").click(function() {
      var videoPlay = document.getElementById("videoPlay");
      $(this).hide();
      $("#showPlay").show();
      videoPlay.play();
    });

    $(".client-box").slide({
      titCell: ".client-tab li",
      mainCell: ".client-con",
      effect: "leftLoop"
    });

    // 视频切换
    $(".multiple-fps").slide({
      titCell: ".multiple-tab a",
      mainCell: ".multiple-con",
      effect: "leftLoop",
      trigger: "click",
      startFun: function(i, c) {
        $(".multiple-con li video")[0].pause();
        $(".multiple-con li video")[0].muted = false;
        $(".multiple-con video")
          .eq(i + 1)[0]
          .play();
      }
    });
    // 换成二维码图片
    function changeImage(val, type) {
      if ("1" == type) {
        if ("1" == val) {
          var subtitle02ele = document.getElementById("sub-title02");
          subtitle02ele.hidden = true;
          var subtitle02divele = document.getElementById("sub-title02div");
          subtitle02divele.hidden = false;
        } else if ("2" == val) {
          var subtitle02ele = document.getElementById("sub-title02");
          subtitle02ele.hidden = false;
          var subtitle02divele = document.getElementById("sub-title02div");
          subtitle02divele.hidden = true;
        }
      } else if ("2" == type) {
        if ("1" == val) {
        } else if ("2" == val) {
        }
      }
    }

    function changeImageTV(val, type) {
      if ("1" == type) {
        if ("1" == val) {
          var subtitle03ele = document.getElementById("sub-title02_2");
          subtitle03ele.hidden = true;
          var subtitle03divele = document.getElementById("sub-title02div_2");
          subtitle03divele.hidden = false;
        } else if ("2" == val) {
          var subtitle03ele = document.getElementById("sub-title02_2");
          subtitle03ele.hidden = false;
          var subtitle03divele = document.getElementById("sub-title02div_2");
          subtitle03divele.hidden = true;
        }
      } else if ("2" == type) {
        if ("1" == val) {
        } else if ("2" == val) {
        }
      }
    }

    //val 1：代表悬浮 2：代表正常
    //type： 1：代表图片更换为二维码。2：代表点击下载链接
    $("#btn-type03_1").hover(
      function() {
        changeImage(1, 1);
      },
      function() {
        changeImage(2, 1);
      }
    );

    $("#btn-type03_2").hover(
        function() {
          changeImageTV(1, 1);
        },
        function() {
          changeImageTV(2, 1);
        }
    );
    screenFirst();
  }
};
</script>

<style lang="scss" >
#homePage {
  a {
    display: inline-block;
  }
  height: auto;
  color: #fff;
  background: #202e40;
  .btn-type01 {
    display: inline-block;
    width: 146px;
    height: 54px;
    margin-top: 55px;
    line-height: 54px;
    color: #fff;
    font-size: 18px;
    text-align: center;
    background: url(~assets/img/btn_bg.png) no-repeat;
    transition: 0.4s;
  }
  .btn-type01:hover {
    border-radius: 99px;
    background: #56e3ea;
  }
}

.home-section01 {
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 1080px;
  box-sizing: border-box;
  background: url(~assets/img/home_bg.jpg) no-repeat center top;
  background-size: cover;
}
.screen-first {
  width: 100%;
  height: 100%;
  max-height: 1080px;
}
.main-box {
  padding-top: 50px;
  padding-bottom: 100px;
}
.slogan {
  width: 840px;
  height: 170px;
  margin: 0 auto 60px;
  text-indent: -9999px;
  background: url(~assets/img/slogan.png) no-repeat;
  background-size: 100% 100%;
  animation: zoomIn 0.6s;
}
.video-box {
  position: relative;
  width: 750px;
  height: 422px;
  padding: 4px;
  margin: 0 auto;
  background: url(~assets/img/video_bg.png) no-repeat;
  animation: zoomIn 0.6s;
  background-size: 100% 100%;
}
.ico-play {
  position: relative;
  display: block;
  width: 750px;
  height: 422px;
}
.ico-play:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 41px;
  margin: -20px 0 0 -20px;
  background: url(~assets/img/main_bg.png) no-repeat -140px -150px;
}
.ico-play:hover:after {
  opacity: 0.8;
}
.ico-play:active:after {
  opacity: 0.6;
}
#showPlay {
  display: none;
}
#showPlay,
#showPlay video {
  width: 100%;
  height: 100%;
}
#showPlay video {
  display: block;
  object-fit: fill;
}

/* backToNext */

@keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@-webkit-keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    -ms-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    -ms-transform: none;
    transform: none;
  }
}

/* home-section02 */
.home-section02 {
  height: 675px;
  padding-top: 88px;
  background: url(~assets/img/home/img_data.gif) no-repeat center 88px;
}
.data-describle {
  width: 490px;
  padding-top: 280px;
  margin-left: 710px;
  color: #fff;
  text-align: center;
  letter-spacing: 1px;
}
.data-describle h3 {
  margin-bottom: 30px;
  text-align: center;
}
.data-describle p {
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}

/* home-section03 */
.home-section03 {
  padding: 67px 0 0px;
}
.home-section03 .client-box {
  padding-top: 80px;
}
.client-tab {
  margin-bottom: 60px;
  border-bottom: 1px solid #56e3ea;
  overflow: hidden;
}

.client-tab li {
  position: relative;
  float: left;
  width: 200px;
  padding-bottom: 16px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 20px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  // padding: 0 20px;
}
.client-tab .on {
  color: #56e3ea;
  border-bottom: 4px solid #56e3ea;
}
.client-tab .icon-client {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 8px;
  background: url(~assets/img/main_bg.png) no-repeat;
  vertical-align: middle;
  text-align: center;
}
.client-tab .icon-android {
  background-position: 0 -74px;
}
.client-tab .icon-androidTv {
  background-position: -36px -74px;
}
.client-tab .icon-Windows {
  background-position: -72px -74px;
}
.client-tab .icon-Mac {
  // background-position: -108px -74px;
  background: url(~assets/img/home/mac.png) no-repeat;
  margin-top: -3px;
}
.client-tab .icon-iOS {
  background-position: -144px -74px;
}
.client-tab .icon-UOS {
  background: url(~assets/img/home/uos.png) no-repeat;
  margin-top: -3px;
}

.client-tab .on .icon-android {
  background-position: 0 -110px;
}
.client-tab .on .icon-androidTv {
  background-position: -36px -110px;
}
.client-tab .on .icon-Windows {
  background-position: -72px -110px;
}
.client-tab .on .icon-Mac {
  // background-position: -108px -110px;
  background: url(~assets/img/home/mac_active.png) no-repeat;
}
.client-tab .on .icon-UOS {
  background: url(~assets/img/home/uos_active.png) no-repeat;
}
.client-tab .on .icon-iOS {
  background-position: -144px -110px;
}
.client-info {
  overflow: hidden;
  padding-bottom: 160px;
}

.client-info dt {
  float: left;
  width: 660px;
  padding-left: 61px;
}

.client-info dt img {
  width: 660px;
  height: 373px;
}
.client-info dd {
  float: right;
  width: 479px;
  padding-top: 134px;
  text-align: center;
}
.client-info h3 {
  margin-bottom: 40px;
}

.btn-type03,
.btn-type03_1 {
  display: inline-block;
  width: 127px;
  height: 38px;
  color: #fff;
  font-size: 16px;
  line-height: 36px;
  text-align: center;
  background: url(~assets/img/main_bg.png) no-repeat 0 -150px;
  letter-spacing: 1px;
}
.btn-type03:hover,
.btn-type03_1:hover {
  background-position: 0 -190px;
  color: #fff;
}

.home-section04 {
  height: 948px;
  background: url(~assets/img/home/img_control.jpg) no-repeat center top;
}

/* home-section05 */
.home-section05 {
  margin-bottom: 115px;
}
.multiple-fps {
  margin-top: 80px;
}
.multiple-con {
  position: relative;
  width: 1200px;
  height: 506px;
  border-radius: 20px;
  box-shadow: 0 4px 15px 0 #9cc7ff;
}
.multiple-con img,
.multiple-con video {
  width: 1200px;
  height: 506px;
  border-radius: 20px;
  object-fit: fill;
}
.multiple-tab {
  margin-top: 24px;
  font-size: 0;
  text-align: center;
}
.multiple-tab a {
  display: inline-block;
  width: 124px;
  height: 32px;
  margin: 0 1px;
  background: url(~assets/img/btn_fps.png) no-repeat;
}
.multiple-tab a:nth-child(1) {
  background-position: 0 0;
}
.multiple-tab a:nth-child(2) {
  background-position: -125px 0;
}
.multiple-tab a:nth-child(3) {
  background-position: -250px 0;
}
.multiple-tab a:nth-child(4) {
  background-position: -375px 0;
}
.multiple-tab a:nth-child(1):hover {
  background-position: 0 -32px;
}
.multiple-tab a:nth-child(2):hover {
  background-position: -125px -32px;
}
.multiple-tab a:nth-child(3):hover {
  background-position: -250px -32px;
}
.multiple-tab a:nth-child(4):hover {
  background-position: -375px -32px;
}
.multiple-tab a:nth-child(1):active {
  background-position: 0 0;
}
.multiple-tab a:nth-child(2):active {
  background-position: -125px 0;
}
.multiple-tab a:nth-child(3):active {
  background-position: -250px 0;
}
.multiple-tab a:nth-child(4):active {
  background-position: -375px 0;
}
.multiple-tab a:nth-child(1).on {
  background-position: 0 -64px;
}
.multiple-tab a:nth-child(2).on {
  background-position: -125px -64px;
}
.multiple-tab a:nth-child(3).on {
  background-position: -250px -64px;
}
.multiple-tab a:nth-child(4).on {
  background-position: -375px -64px;
}

/* home-section06 */
.home-section06 {
  height: 650px;
  margin-bottom: 160px;
}
.pic-wall {
  position: relative;
  width: 1200px;
  height: 400px;
  padding: 69px 0;
  overflow: hidden;
}
.pic-wall:before {
  content: "";
  position: absolute;
  top: -56px;
  left: 0;
  width: 1200px;
  height: 650px;
  background: url(~assets/img/home/img_game_bg.png) no-repeat center center;
  z-index: 2;
}
.pic-scroll {
  animation: linear scrollHor 7s infinite;
  z-index: 1;
}
@-webkit-keyframes scrollHor {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-1200px);
    transform: translateX(-1200px);
  }
}
@-moz-keyframes scrollHor {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-1200px);
    transform: translateX(-1200px);
  }
}
@-o-keyframes scrollHor {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-1200px);
    transform: translateX(-1200px);
  }
}
@keyframes scrollHor {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-1200px);
    transform: translateX(-1200px);
  }
}

.home-section07 {
  padding-bottom: 160px;
}
.advantage-list {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 80px;
}
.advantage-list li {
  position: relative;
  width: 200px;
  padding-top: 150px;
  text-align: center;
}
.advantage-list li h4 {
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
}
.advantage-list li p {
  font-size: 16px;
  line-height: 16px;
  text-align: center;
}
.advantage-list li:before {
  content: "";
  position: absolute;
  top: 0;
  left: 44px;
  width: 112px;
  height: 112px;
  background: url(~assets/img/home/sprite.png) no-repeat;
}
.advantage-list li:nth-child(2):before {
  background-position: -120px 0;
}
.advantage-list li:nth-child(3):before {
  background-position: -240px 0;
}
.advantage-list li:nth-child(4):before {
  background-position: -360px 0;
}
.advantage-list li:nth-child(5):before {
  background-position: -480px 0;
}
.advantage-list li:nth-child(6):before {
  background-position: -600px 0;
}

.home-section08 {
  height: 320px;
  background: url(~assets/img/home/ready_bg.png) no-repeat center top;
}
.hs08-con {
  padding-top: 152px;
  text-align: center;
}
.txt-type01 {
  font-size: 28px;
  line-height: 44px;
}
.btn-blue,
.btn-green {
  display: inline-block;
  width: 119px;
  height: 44px;
  color: #fff;
  font-size: 16px;
  line-height: 44px;
  border-radius: 22px;
  text-align: center;
}
.btn-blue {
  background: linear-gradient(to left, #1673bc, #35aae1);
  background: -ms-linear-gradient(to left, #1673bc, #35aae1);
  background: -webkit-linear-gradient(to left, #1673bc, #35aae1);
  background: -moz-linear-gradient(to left, to left, #1673bc, #35aae1);
}
.btn-blue:hover {
  background: linear-gradient(
    to left,
    rgba(22, 115, 188, 0.8),
    rgba(53, 170, 225, 0.8)
  );
  background: -ms-linear-gradient(
    to left,
    rgba(22, 115, 188, 0.8),
    rgba(53, 170, 225, 0.8)
  );
  background: -webkit-linear-gradient(
    to left,
    rgba(22, 115, 188, 0.8),
    rgba(53, 170, 225, 0.8)
  );
  background: -moz-linear-gradient(
    to left,
    to left,
    rgba(22, 115, 188, 0.8),
    rgba(53, 170, 225, 0.8)
  );
}
.btn-green {
  background: linear-gradient(to left, #16b7bc, #35dde1);
  background: -ms-linear-gradient(to left, #16b7bc, #35dde1);
  background: -webkit-linear-gradient(to left, #16b7bc, #35dde1);
  background: -moz-linear-gradient(to left, to left, #16b7bc, #35dde1);
}
.btn-green:hover {
  background: linear-gradient(
    to left,
    rgba(22, 183, 188, 0.8),
    rgba(53, 221, 225, 0.8)
  );
  background: -ms-linear-gradient(
    to left,
    rgba(22, 183, 188, 0.8),
    rgba(53, 221, 225, 0.8)
  );
  background: -webkit-linear-gradient(
    to left,
    rgba(22, 183, 188, 0.8),
    rgba(53, 221, 225, 0.8)
  );
  background: -moz-linear-gradient(
    to left,
    to left,
    rgba(22, 183, 188, 0.8),
    rgba(53, 221, 225, 0.8)
  );
}
.btn-blue:active,
.btn-green:active {
  opacity: 0.6;
}
.hs08-spaec {
  margin: 0 70px;
}

.submenu {
  /* position:relative; */
  cursor: pointer;
  z-index: 999;
}
.submenu-img {
  padding: 24px 10px;
  cursor: pointer;
}
.submenu-list {
  position: absolute; /* padding-top: 80px; */
  top: 80px;
  right: -8px;
  width: 120px;
  z-index: 999;
  display: none;
}
.submenu-list a {
  position: relative;
  line-height: 30px;
  background: rgba(7, 12, 21, 0.5);
  width: 48px;
  text-align: center;
}
.submenu-list a:hover {
  border: none;
}
.submenu-list li:last-child a {
  border-radius: 0 0 10px 10px;
}
/*.submenu-list .last {border-radius: 0 0  10px 10px;}*/
.title {
  padding-top: 30px;
  margin-bottom: 145px;
  color: #fff;
  font-size: 48px;
  font-weight: bold;
  text-align: center;
}
// .client-wrap .list-type li {
//   float: left;
//   text-align: center;
// }
// .client-wrap .list-type li:nth-child(1) {
//   width: 146px;
//   margin-right: 136px;
// }
// .client-wrap .list-type li:nth-child(2) {
//   width: 146px;
//   margin-right: 140px;
// }
// .client-wrap .list-type li:nth-child(3) {
//   width: 304px;
//   margin-right: 115px;
// }
// .client-wrap .list-type li:nth-child(4) {
//   width: 212px;
// }

.cooperation-list li {
  float: left;
  width: 315px;
  margin-right: 42px;
  margin-left: 42px;
}

.cooperation-list h3 {
  margin: 35px 0 20px;
  color: #56e3ea;
  font-size: 24px;
  font-weight: bold;
  line-height: 30px;
}
.cooperation-list .contact p {
  padding-left: 83px;
  text-indent: -83px;
  color: #c5c5c5;
  font-size: 18px;
  line-height: 30px;
}
.txtspace01 {
  letter-spacing: 6.5px;
}
.txtspace02 {
  letter-spacing: 2px;
}
/* title */
#homePage {
  .main-title13 h2 {
    width: 118px;
    background-position: 0 -480px;
  }
  .main-title14 h2 {
    width: 278px;
    background-position: 0 -520px;
  }
  .main-title15 h2 {
    width: 252px;
    background-position: 0 -560px;
  }
  .main-title16 h2 {
    width: 344px;
    background-position: 0 -600px;
  }
  .main-title17 h2 {
    width: 280px;
    background-position: 0 -640px;
  }
  .main-title18 h2 {
    width: 280px;
    background-position: 0 -760px;
  }
  .main-title19 h2 {
    width: 162px;
    background-position: 0 -800px;
  }
  .main-title20 h2 {
    width: 162px;
    background-position: 0 -840px;
  }
  .main-title21 h2 {
    width: 164px;
    background-position: 0 -880px;
  }
  .main-title22 h2 {
    width: 510px;
    background-position: 0 -920px;
  }
}

.btn-type03 {
  display: inline-block;
  width: 127px;
  height: 38px;
  color: #fff;
  font-size: 16px;
  line-height: 36px;
  background: url(~assets/img/main_bg.png) no-repeat 0 -150px;
}
.btn-type03:hover {
  background-position: 0 -190px;
}
.sub-title {
  position: relative;
  height: 26px;
  margin: 0 auto;
  font-size: 0;
  text-indent: -9999px;
  background: url(~assets/img/sub_title.png) no-repeat;
}
.sub-title:after {
  content: "";
  position: absolute;
  top: 31px;
  left: 50%;
  width: 108px;
  height: 5px;
  margin-left: -54px;
  background: url(~assets/img/sub_title_bg.png) no-repeat;
}
.sub-title01 {
  width: 326px;
}
.sub-title02 {
  width: 250px;
  background-position: 0 -26px;
}
.sub-title03 {
  width: 374px;
  background-position: 0 -52px;
}
.sub-title04 {
  width: 270px;
  background-position: 0 -78px;
}
.sub-title05 {
  width: 392px;
  background-position: 0 -104px;
}
.sub-title_UOS {
  background: url("~assets/img/home/uos_title.png") no-repeat center;
}
.sub-title06 {
  width: 374px;
  background-position: 0 -130px;
}
.uos-dl {
  // overflow: auto;
  .uos_main {
    position: relative;
  }
}
.uos_list {
  display: none;
  width: 127px;
  background: #536b8a;
  border-radius: 10px;
  opacity: 0.8;
  // margin: 12px auto;
  overflow: hidden;
  color: rgba($color: #fff, $alpha: 0.6);
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  margin: auto;
  top: 50px;
  li {
    height: 45px;
    line-height: 44px;
    border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
    font-size: 17px;
    cursor: pointer;
    &:hover {
      background: rgba($color: #89a2c3, $alpha: 0.3);
      color: rgba($color: #fff, $alpha: 1);
    }
    &:active {
      background: rgba($color: #89a2c3, $alpha: 0.2);
      color: rgba($color: #fff, $alpha: 0.6);
    }
    &.not_allowed {
      cursor: not-allowed;
      background: transparent;
      color: rgba($color: #fff, $alpha: 0.1);
    }
  }
}
</style>
<style lang="scss">
.el-dropdown-menu {
  .popper__arrow {
    display: none;
  }
  width: 150px;
  background: #536b8a;
  border-radius: 10px;
  opacity: 0.8;
  padding: 0;
  margin: 0;
  // margin: 12px auto;
  overflow: hidden;

  border: none;
  .el-dropdown-menu__item {
    width: 100%;
    height: 45px;
    padding-top: 0;
    line-height: 44px;
    border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
    font-size: 17px;
    text-align: center;
    padding: 0;
    a {
      display: inline-block;
      color: rgba($color: #fff, $alpha: 0.6);
    }
    cursor: pointer;
    &:hover {
      background: rgba($color: #89a2c3, $alpha: 0.3);
      a {
        color: rgba($color: #fff, $alpha: 1);
      }
    }
    &:active {
      background: rgba($color: #89a2c3, $alpha: 0.2);
      a {
        color: rgba($color: #fff, $alpha: 0.6);
      }
    }
    &.not_allowed {
      cursor: not-allowed;
      background: transparent;
      a {
        cursor: not-allowed;
        color: rgba($color: #fff, $alpha: 0.1);
      }
    }
  }
}
</style>
